import { MenuItem } from "@mui/material";
import MuiTextField from "@mui/material/TextField";

import { useFieldContext } from "./useAppForm";

export function SelectField({
  description,
  getOptionLabel,
  getOptionValue,
  hasEmpty,
  selects,
  emptyLabel = "None",
  ...props
}) {
  const field = useFieldContext();

  return (
    <MuiTextField
      fullWidth
      select
      onChange={(e) => field.handleChange(e.target.value)}
      value={field.state.value ?? ""}
      error={field.state.meta.errors.length >= 1}
      helperText={field.state.meta.errors?.map((error) => error?.message).join(" ") || description}
      {...props}
    >
      {hasEmpty !== undefined && hasEmpty !== false && (
        <MenuItem value={hasEmpty} id={`${props.id}-null`}>
          <i>{emptyLabel}</i>
        </MenuItem>
      )}
      {Array.isArray(selects) &&
        selects.map((row, key) => {
          const isObject = typeof row === "object" && row !== null;

          return (
            <MenuItem
              key={key}
              value={isObject ? getOptionValue(row) : row}
              id={`${props.id}-${key}`}
              disabled={isObject ? row.disabled : false}
            >
              {getOptionLabel(row)}
            </MenuItem>
          );
        })}
      {selects.length === 0 && (hasEmpty === undefined || hasEmpty === false) && (
        <MenuItem disabled>No options available</MenuItem>
      )}
    </MuiTextField>
  );
}
